<template>
  <div class="container" :data-testid="TEST_ID.SOLICITUDES_EDICION.ROOT">
    <div v-if="!guardado" class="title">
      <span>{{ $t('SOLICITUDES_solicitud_servicio') }}</span>
      <span class="numeroSolicitudServicio">{{ nro_solicitud }}</span>
    </div>

<div style="width: 70%; margin-left:15%;" v-if="guardado" class="title" >       
    {{ $t('SOLICITUDES_solicitud_servicio_guardada') }}    
    <div style="float: right">
      <!-- <router-link :to="{ name: 'Nueva Solicitud'}"> -->
        <el-button @click="onNuevaSolicitud" type="primary" icon="Plus" size="default" round>{{ $t('GENERAL_nuevo') }}</el-button>
      <!-- </router-link> -->
    </div>
</div>
   

    <div class="container_cards" v-if="!guardado">
      <el-card>
        <!-- Seccion de tipo servicios -->
        <el-row :gutter="20">
          <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
            <el-row>
              <div class="tipoService" :data-testid="TEST_ID.SOLICITUDES_EDICION.TIPO_LABEL">{{ $t('SOLICITUDES_tipo_servicio') }}</div>
            </el-row>
            <el-row>
              <el-radio-group v-model="tipo_servicio" :disabled="esEdicion">
                <el-radio :value="$t('SOLICITUDES_check_garantia')">
                  <span :data-testid="TEST_ID.SOLICITUDES_EDICION.TIPO_OPTION_GARANTIA">{{ $t('SOLICITUDES_check_garantia') }}</span>
                </el-radio>
                <el-radio :value="$t('SOLICITUDES_check_reparacion')">
                  <span :data-testid="TEST_ID.SOLICITUDES_EDICION.TIPO_OPTION_REPARACION">{{ $t('SOLICITUDES_check_reparacion') }}</span>
                </el-radio>
                <el-radio :value="$t('SOLICITUDES_check_canje')">
                  <span :data-testid="TEST_ID.SOLICITUDES_EDICION.TIPO_OPTION_CANJE">{{ $t('SOLICITUDES_check_canje') }}</span>
                </el-radio>
              </el-radio-group>
            </el-row>
            <el-row
              v-if="tipo_servicio == $t('SOLICITUDES_check_canje')"
              style="text-align:left;margin-top:10px"
            >
              <div class="tipoService">{{ $t('SOLICITUDES_motivo') }}</div>
              <el-select
                v-model="motivo"
                :placeholder="$t('GENERAL_seleccione')"
                size="small"
                @input="changeItem"
                style="margin-top:10px !important;"
              >
                <el-option
                  v-for="motivo in motivos"
                  :key="motivo.Id"
                  :label="motivo.Descripcion"
                  :value="motivo.Id"
                ></el-option>
              </el-select>
            </el-row>
          </el-col>
          <!-- Sección de inputs -->
          <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <NumeroSerieInput
                  :name="'nro_serie'"
                  :label="this.$t('GARANTIAS_ns')"
                  v-model="nro_serie"
                  :readonly="esEdicion"
                  :onChange="this.onNumeroSerieChange"
                  :customClases="'nro_serie gridItem'"
                  @ocultar="this.onOcultar"
                />
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-row>
                  <el-col :span="24">
                    <div class="patenteContainer">
                      <div
                        class="label"
                      >{{ tipo_servicio == this.$t('SOLICITUDES_check_garantia') ? $t('GARANTIAS_tiene_patente') : $t('GARANTIAS_patente')}}</div>

                      <el-switch
                        class="switch"
                        v-model="tienePatente"
                        size="small"
                        :disabled="tipo_servicio == this.$t('SOLICITUDES_check_reparacion')"
                      />
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-input
                    :placeholder="tienePatente || tipo_servicio != this.$t('SOLICITUDES_check_garantia') ? $t('GARANTIAS_nro_patente') :  $t('GARANTIAS_marca_modelo_unidad')"
                    size="small"
                    v-model="patente"
                    @blur="formatPatente"
                  />
                </el-row>
              </el-col>
            </el-row>

            <el-row v-if="!ocultarNsAsociado && nro_serie_valido" :gutter="20">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <NumeroSerieInput
                  :name="'nro_serie_asoc'"
                  :label="this.$t('GARANTIAS_ns_asoc')"
                  v-model="nro_serie_asoc"
                  :readonly="esEdicion"
                  :onChange="this.onNumeroSerieChange"
                  :customClases="'nro_serie gridItem'"
                />
              </el-col>
            </el-row>

            <el-row v-if="esEdicion" :gutter="20">
              <el-col :span="24">
                <div class="label">{{$t('SOLICITUDES_observaciones1')}}</div>
                <el-input
                  :placeholder="$t('SOLICITUDES_placeholder_observaciones')"
                  type="textarea"
                  :rows="1"
                  v-model="obs_img_1"
                />
                <FileUpload
                  name="imagen_1"
                  :limit="1"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :storeAction="'solicitudes/uploadImagen'"
                  :files="imagen_1"
                  :temporalId="id_solicitud"
                  :numeroArchivo="1"
                  :onFileListChange="imagenChanged"
                  :withBtn="false"
                  :showPreview="true"
                  style="text-align: left; margin-top: 5px"
                />
              </el-col>
            </el-row>

            <el-row v-if="esEdicion" :gutter="20">
              <el-col :span="24">
                <div class="label">{{$t('SOLICITUDES_observaciones2')}}</div>
                <el-input
                  :placeholder="$t('SOLICITUDES_placeholder_observaciones')"
                  type="textarea"
                  :rows="1"
                  v-model="obs_img_2"
                />
                <FileUpload
                  name="imagen_2"
                  :limit="1"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :files="imagen_2"
                  :storeAction="'solicitudes/uploadImagen'"
                  :onFileListChange="imagenChanged"
                  :temporalId="id_solicitud"
                  :numeroArchivo="2"
                  :withBtn="false"
                  :showPreview="true"
                  style="text-align: left; margin-top: 5px"
                />
              </el-col>
            </el-row>

            <el-row v-if="esEdicion" :gutter="20">
              <el-col :span="24">
                <div class="label">{{$t('SOLICITUDES_observaciones3')}}</div>
                <el-input
                  :placeholder="$t('SOLICITUDES_placeholder_observaciones')"
                  type="textarea"
                  :rows="1"
                  v-model="obs_img_3"
                />
                <FileUpload
                  name="imagen_3"
                  :limit="1"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :files="imagen_3"
                  :storeAction="'solicitudes/uploadImagen'"
                  :temporalId="id_solicitud"
                  :numeroArchivo="3"
                  :onFileListChange="imagenChanged"
                  :withBtn="false"
                  :showPreview="true"
                  style="text-align: left; margin-top: 5px"
                />
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <div class="label">{{ $t('SOLICITUDES_label_observaciones') }}</div>
                <el-input
                  :placeholder="$t('SOLICITUDES_placeholder_observaciones')"
                  type="textarea"
                  :rows="2"
                  v-model="observaciones"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div class="btnContainer" v-if="!guardado">
      <el-button
        :data-testid="TEST_ID.SOLICITUDES_EDICION.BUTTON_GUARDAR"
        type="primary"
        @click="() => esEdicion === false ? this.nuevaSolicitud() : this.editarSolicitud()"
        :loading="loading"
      >{{ $t('GENERAL_saveBtn') }}</el-button>

      <router-link :to="{ name: 'Solicitudes', query: { keepFilter: 'true', ns: this.nro_serie  }}">
        <el-button :data-testid="TEST_ID.SOLICITUDES_EDICION.BUTTON_CANCELAR">{{$t('GENERAL_cancelBtn')}}</el-button>
      </router-link>
    </div>

    <!--Seccion Datos guardados -->
    <div class="container_cards" v-if="guardado">
      <el-card class="cardGuardado">
        <div class="tipoService" style="margin-bottom:10px">{{ solicitudNumero }}</div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7" class="guardado_col1">
                <div class="greyLabel">{{ $t('SOLICITUDES_tipo_servicio') }}</div>
              </el-col>
              <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17" class="guardado_col1">
                <div class="blackLabel">{{tipo_servicio}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="tipo_servicio == $t('SOLICITUDES_check_canje')">
              <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7" class="guardado_col1">
                <div class="greyLabel">{{ $t('SOLICITUDES_motivo') }}</div>
              </el-col>
              <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17" class="guardado_col1">
                <div class="blackLabel">{{descripcionMotivo}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7" class="guardado_col1">
                <div class="greyLabel">{{ $t('GARANTIAS_ns') }}</div>
              </el-col>
              <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17" class="guardado_col1">
                <div class="blackLabel">{{nro_serie}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7" class="guardado_col1">
                <div
                  class="greyLabel"
                  v-if="tipo_servicio == this.$t('SOLICITUDES_check_garantia')"
                >{{ tienePatente ? $t('GARANTIAS_patente'): $t('GARANTIAS_marca_modelo_unidad')}}</div>
                <div
                  class="greyLabel"
                  v-if="tipo_servicio != this.$t('SOLICITUDES_check_garantia')"
                >{{ $t('GARANTIAS_patente')}}</div>
              </el-col>
              <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17" class="guardado_col1">
                <div class="blackLabel">{{patente}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7" class="guardado_col1">
                <div class="greyLabel">{{ $t('GARANTIAS_ns_asoc') }}</div>
              </el-col>
              <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17" class="guardado_col1">
                <div class="blackLabel">{{nro_serie_asoc}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7" class="guardado_col1">
                <div class="greyLabel">{{ $t('SOLICITUDES_label_observaciones') }}</div>
              </el-col>
              <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17" class="guardado_col1">
                <div class="blackLabel">{{observaciones}}</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div class="btnContainer" v-if="guardado">
      <el-button @click="onEditarSolicitud()">{{ $t('GENERAL_editBtn') }}</el-button>
      <router-link :to="{ name: 'Solicitudes', query: { keepFilter: 'true', ns: this.nro_serie }}">
        <el-button type="primary">{{ $t('GENERAL_acceptBtn') }}</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ElMessageBox } from "element-plus";
import NumeroSerieInput from "../NumeroSerieInput";
import FileUpload from "@/components/FileUpload";
import {
  mostrarMensajeInternacionalizado
} from "../MensajeInternacionalizado/index";
import { showError, showSuccess } from "../Mensaje";
import TEST_ID from "@/testIds.json";

export default {
  components: { NumeroSerieInput, FileUpload },
  props: { ocultar: Function },
  data() {
    return {
      TEST_ID,
      esEdicion: false,
      tipo_servicio: this.$t("SOLICITUDES_check_garantia"),
      motivo: undefined,
      motivos: [],
      id_solicitud: undefined,
      nro_solicitud: undefined,
      nro_serie: "",
      nro_serie_valido: false,
      nro_serie_asoc: "",
      nro_serie_asoc_valido: false,
      tienePatente: true,
      patente: "",
      observaciones: "",
      obs_img_1: "",
      obs_img_2: "",
      obs_img_3: "",
      imagen_1: [],
      imagen_2: [],
      imagen_3: [],
      descripcionMotivo: "",
      solicitudNumero: this.$t("SOLICITUDES_solicitud"),
      ocultarNsAsociado: true,
      guardado: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
    }),
  },
  watch: {
    tipo_servicio(newVal) {
      if (newVal != this.$t("SOLICITUDES_check_garantia"))
        this.tienePatente = true;
    },
    tienePatente(newVal, oldVal) {
      if (newVal != oldVal) this.patente = "";
    },
  },
  methods: {
    cargarSolicitud(solicitud) {
      // cargo la solicitud a editar
      this.id_solicitud = solicitud.IdSolicitud;
      this.nro_solicitud = solicitud.NumeroSolicitud;
      this.nro_serie = solicitud.Ns;
      this.nro_serie_asoc = solicitud.NsAsociado;
      this.tienePatente = solicitud.Patente ? true : false;
      this.patente = solicitud.Patente
        ? solicitud.Patente
        : solicitud.MarcaModelo;
      this.motivo = solicitud.IdMotivo;
      this.observaciones = solicitud.Observaciones;

      switch (solicitud.TipoServicio) {
        case "G":
          this.tipo_servicio = this.$t("SOLICITUDES_check_garantia");
          break;
        case "R":
          this.tipo_servicio = this.$t("SOLICITUDES_check_reparacion");
          break;
        case "C":
          this.tipo_servicio = this.$t("SOLICITUDES_check_canje");
          break;
      }

      // cargo las imágenes con sus observaciones
      for (var i = 0; i < solicitud.Imagenes.length; i++) {
        // cargo la observación de la imagen
        this[`obs_img_${i + 1}`] = solicitud.Imagenes[i].Observaciones;

        // busco la imagen en el servidor
        this.cargarImagen(solicitud, i);
      }
    },

    cargarImagen(solicitud, index) {
      // busco la imagen en el servidor
      let payload = {
        solicitudId: solicitud.IdSolicitud,
        nombreArchivo: solicitud.Imagenes[index].Path
      };
      this.$store.dispatch("solicitudes/getImagen", payload).then(data => {
        if (data.CodigoResultado === 0) {
          let url = "data:image/png;base64," + data.Datos;
          fetch(url)
            .then(res => res.blob())
            .then(blob => {
              this[`imagen_${index + 1}`] = [
                {
                  name: solicitud.Imagenes[index].Path,
                  url: URL.createObjectURL(blob)
                }
              ];
            });
        }
      });
    },

    imagenChanged(name, fileList) {
      switch (name) {
        case "imagen_1":
          this.imagen_1 = fileList;
          break;
        case "imagen_2":
          this.imagen_2 = fileList;
          break;
        case "imagen_3":
          this.imagen_3 = fileList;
          break;
      }
    },

    onNumeroSerieChange(payload) {
      
      this[payload.name] = payload.value;
      this[payload.name + "_valido"] = payload.valid;
    },

    beforeRemove(file) {
      return ElMessageBox.confirm(
        this.$t("GENERAL_img_remove_confirm")`${file.name}?`,
        this.$t("GENERAL_atencion"),
        { type: "warning" }
      );
    },

    handleError() {
      showError(this.$t("GENERAL_img_upload_error"));
    },

    formatPatente(event) {
      if (this.tienePatente)
        this.patente = event.target.value.split(" ").join("");
    },

    nuevaSolicitud() {
      this.loading = true;
      // validaciones
      let valida = true;

      if (this.tipo_servicio === "Canje" && !this.motivo) {
        showError(this.$t("SOLICITUDES_motivo_missing"));
        valida = false;
      }

      if (!this.nro_serie || !this.nro_serie_valido) {
        showError(this.$t("SOLICITUDES_nro_serie_missing"));
        valida = false;
      }

      if (this.nro_serie_asoc && !this.nro_serie_asoc_valido) {
        showError(this.$t("SOLICITUDES_nro_serie_asociado_missing"));
        valida = false;
      }

      if (!this.observaciones) {
        showError(this.$t("SOLICITUDES_observaciones_missing"));
        valida = false;
      }

      if (!this.patente && this.tipo_servicio != "Canje") {
        let mensaje = this.tienePatente
          ? this.$t("SOLICITUDES_patente_missing")
          : this.$t("SOLICITUDES_marca_modelo_missing");
        showError(mensaje);
        valida = false;
      }

      if (!valida) {
        this.loading = false;
        return;
      }

      // armo el payload
      let payload = {
        guid_app: undefined,
        id_Usuario: this.idUsuario,
        tipo: this.tipo_servicio,
        ns_o_lote_o_codigo: this.nro_serie,
        ns_padre: this.nro_serie_asoc,
        marca_modelo: !this.tienePatente ? this.patente : "",
        pat_motor: this.tienePatente ? this.patente : "",
        motivo:
          this.tipo_servicio == this.$t("SOLICITUDES_check_canje")
            ? this.motivo
            : undefined,
        descripcion: this.observaciones
      };

      // guardo la solicitud
      this.$store
        .dispatch("solicitudes/nuevaSolicitud", payload)
        .then(result => {
          if (result.CodigoResultado !== 0)
            mostrarMensajeInternacionalizado(
              result.CodigoResultado,
              result.DescripcionResultado
            );
          else {
            this.solicitudNumero = this.$t("SOLICITUDES_solicitud").replace(
              "[nro_solicitud]",
              result.Datos
            );
            this.guardado = true;
            this.id_solicitud = result.Datos;
          }
        })
        .finally(() => (this.loading = false));
    },
    editarSolicitud() {
      this.loading = true;

      // validaciones
      let valida = true;

      if (!this.patente) {
        let mensaje = this.tienePatente
          ? this.$t("SOLICITUDES_patente_missing")
          : this.$t("SOLICITUDES_marca_modelo_missing");
        showError(mensaje);
        valida = false;
      }

      if (!this.observaciones) {
        showError(this.$t("SOLICITUDES_observaciones_missing"));
        valida = false;
      }

      if (this.tipo_servicio === "Canje" && !this.motivo) {
        showError(this.$t("SOLICITUDES_motivo_missing"));
        valida = false;
      }

      if (!valida) {
        this.loading = false;
        return;
      }

      // armo el payload
      let payload = {};
      payload.id_solicitud = this.id_solicitud;
      payload.numero_solicitud = this.nro_solicitud;
      (payload.marca_modelo = !this.tienePatente ? this.patente : ""),
        (payload.pat_motor = this.tienePatente ? this.patente : ""),
        (payload.motivo =
          this.tipo_servicio == this.$t("SOLICITUDES_check_canje")
            ? this.motivo
            : undefined),
        (payload.descripcion = this.observaciones);

      // cargo las imágenes
      payload.imagenes = [];
      if (this.imagen_1 !== undefined && this.imagen_1.length > 0)
        payload.imagenes.push({
          nombre_archivo: this.getNombreArchivo(this.imagen_1[0].name, 1),
          observaciones: this.obs_img_1
        });

      if (this.imagen_2 !== undefined && this.imagen_2.length > 0)
        payload.imagenes.push({
          nombre_archivo: this.getNombreArchivo(this.imagen_2[0].name, 2),
          observaciones: this.obs_img_2
        });

      if (this.imagen_3 !== undefined && this.imagen_3.length > 0)
        payload.imagenes.push({
          nombre_archivo: this.getNombreArchivo(this.imagen_3[0].name, 3),
          observaciones: this.obs_img_3
        });

      // persisto la edición de solicitud
      this.$store
        .dispatch("solicitudes/editarSolicitud", payload)
        .then(data => {
          if (data.CodigoResultado === 0) {
            showSuccess(this.$t("SOLICITUDES_edicion_success"));
            this.$router.push({ name: "Solicitudes" });
          } else
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
        })
        .finally(() => (this.loading = false));
    },
    onEditarSolicitud() {
      this.$router.push({ path: `/solicitudes/edicion/${this.id_solicitud}` });
      this.$router.go();
    },
    btnNuevaSolicitud() {
      this.$router.push({ path: `/solicitudes/nueva` });
    },
    getNombreArchivo(nombreOriginal, numeroArchivo) {
      // armo el nombre del archivo (ejemplo Id_solic_servicio + ‘_’+_numero_archivo.jpg)
      let numeroSolicitud = this.nro_solicitud;
      let extensionArchivo = nombreOriginal.split(".").pop();

      return `${numeroSolicitud}_${numeroArchivo}.${extensionArchivo}`;
    },
    onOcultar(esNs) {
      if (esNs == "S") this.ocultarNsAsociado = true;
      else this.ocultarNsAsociado = false;
    },
    changeItem: function(selected) {
      this.descripcionMotivo = this.motivos.filter(
        m => m.Id == selected
      )[0].Descripcion;
    },
    onNuevaSolicitud() {
      this.$router.go();
    },
  },
  created() {
    this.$store.dispatch("solicitudes/getMotivos").then(data => {
      if (data.CodigoResultado === 0) this.motivos = data.Datos;
      else
        mostrarMensajeInternacionalizado(
          data.CodigoResultado,
          data.DescripcionResultado
        );
    });
  },
  mounted() {
    if (this.$route.params.id) {
      // indico que es una edición de solicitud de servicio
      this.esEdicion = true;

      // busco la solicitud a editar
      this.$store
        .dispatch("solicitudes/getSolicitud", {
          solicitudId: this.$route.params.id
        })
        .then(data => {
          if (data.CodigoResultado === 0) this.cargarSolicitud(data.Datos);
          else
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
        });
    }
  }
};
</script>

<style scoped>
.numeroSolicitudServicio {
  margin-left: 5px;
}

.container_cards {
  display: flex;
}
.cardGuardado {
  width: 70%;
  margin-left: 15%;
  margin-right: 15%;
}
.guardado_col1 {
  padding-bottom: 7px;
  vertical-align: top;
  text-align: left;
}
.guardado_col2 {
  padding-bottom: 7px;
  vertical-align: top;
  text-align: left;
}

.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.outer_container {
  margin: 15px auto;
  width: 99%;
  max-width: 800px;
}
.container {
  padding: 0 30px;
  max-width: 800px;
  margin: 0 auto;
}
.container_radio {
  flex: 20%;
  padding: 20px;
}
.container_input {
  /* flex: 55%; */
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  padding: 20px 0;
}

.patenteContainer {
  display: inline-flex;
  width: 100%;
}
.patenteContainer .label {
  float: left;
  width: calc(100% - 40px);
}
.patenteContainer .switch {
  margin-top: 12px;
}

@media (max-width: 1110px) {
  .container_input {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 1060px;
  }
}
.textarea {
  position: relative;
  grid-column-start: 1;
  grid-column-end: 3;
}
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
  margin-bottom: 30px;
}
.tipoService {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}
.motivo {
  margin-top: 20px;
}

.el-select {
  display: block;
}

.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.label {
  text-align: left;
  font-size: 14px;
  margin-bottom: 4px;
  margin-top: 15px;
}

.btnContainer {
  margin-top: 20px;
}
@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .title {
    text-align: center;
  }
  .container_radio {
    padding: 0px 20px 20px 20px;
  }
  .container_input {
    flex: none;
    padding: 0 20px;
  }
  .textarea {
    grid-column-start: 1;
    grid-column-end: 1;
  }
}

.descripcion {
  text-align: left;
  font-size: 12px;
  margin-top: 10px;
  color: #666;
}
.descripcion.invalido {
  color: #f44336;
}
</style>

<style>
.el-radio__input.is-disabled.is-checked + span.el-radio__label {
  color: #409eff;
}
</style>